import _ from 'lodash';
import { type OptionType } from '../types/common';
import { store } from '../store/store';

export const getOptionLabel = (options: OptionType[], value: string | undefined | null): any => {
  return options.find((option) => option.value === value)?.label;
};

// Format data to objects
export const restructureNonFieldPermissions = (
  data: string[],
  permissionIdentifier: string,
  allFieldValues?: any
): any => {
  return data?.map((item: string) => {
    const permissionParts = item.replaceAll(permissionIdentifier, '').split('.');
    const displayName = (item && allFieldValues && allFieldValues[item]) ?? '';
    return {
      groupKey: permissionParts[0],
      key: item,
      text: permissionParts.length > 1 ? permissionParts[1] : 'View',
      displayName: displayName,
    };
  });
};

// Filter data which has permissionIdentifier and is granted
const getCustomerPolicies = (policies: any, permissionIdentifier: string): string[] =>
  Object.entries(policies ?? {})
    .filter(([key, value]) => key.startsWith(permissionIdentifier) && value === true)
    .map(([key]) => key);

// Filter data which don't have FieldLevel
export const getNonFieldLevelPermissions = (permissions: any): any => {
  return permissions.filter((item: any) => {
    return item.includes('.FieldLevel.') === false;
  });
};

// Filter data which have FieldLevel
export const getFieldLevelPermissions = (permissions: any): any => {
  return permissions.filter((item: any) => {
    return item.includes('.FieldLevel.');
  });
};

// Converts Strings Data with value to groups objects
export const getFilteredPermissionData = (
  policies: any,
  permissionInfo?: string,
  allFieldValues?: any,
  accountType?: string
): any => {
  //   const permissionIdentifier = permissionInfo ?? 'CustomerService.Customer.';
  //   const permissionIdentifierField = 'CustomerService.Customer.FieldLevel.';

  //   const customerPolicies = getCustomerPolicies(policies, permissionIdentifier);

  //   const nonFieldLevelPermissions = getNonFieldLevelPermissions(customerPolicies);
  //   const fieldLevelPermissions = getFieldLevelPermissions(customerPolicies);

  //   const nonFieldLevelPermissionsData = restructureNonFieldPermissions(
  //     nonFieldLevelPermissions,
  //     permissionIdentifier
  //   );
  //   const fieldLevelPermissionsData = restructureNonFieldPermissions(
  //     fieldLevelPermissions,
  //     permissionIdentifierField
  //   );

  //   const nonFieldLevelPermissionsGroups = _.groupBy(
  //     nonFieldLevelPermissionsData,
  //     (item) => item.groupKey
  //   );

  //   const fieldLevelPermissionsGroups = _.groupBy(
  //     fieldLevelPermissionsData,
  //     (item) => item.groupKey
  //   );

  //   return { nonFieldLevelPermissionsGroups, fieldLevelPermissionsGroups };

  const ACCOUNT_TYPES = new Set();

  Object.entries(policies).forEach(([key, value]) => {
    const accountType = key.split('.')[1];
    if (accountType) {
      ACCOUNT_TYPES.add(accountType);
    }
  });

  // const ACCOUNT_TYPES = ['Customer', 'Vendor'];
  let allNonFieldLevelPermissionsGroups: any = {};
  let allFieldLevelPermissionsGroups: any = {};

  ACCOUNT_TYPES.forEach((dataType) => {
    const permissionIdentifier = `CustomerService.${dataType}.`;
    const permissionIdentifierField = `CustomerService.${dataType}.FieldLevel.`;

    const customerPolicies = getCustomerPolicies(policies, permissionIdentifier);

    const nonFieldLevelPermissions = getNonFieldLevelPermissions(customerPolicies);
    const fieldLevelPermissions = getFieldLevelPermissions(customerPolicies);

    const nonFieldLevelPermissionsData = restructureNonFieldPermissions(
      nonFieldLevelPermissions,
      permissionIdentifier,
      allFieldValues
    );
    const fieldLevelPermissionsData = restructureNonFieldPermissions(
      fieldLevelPermissions,
      permissionIdentifierField
    );

    const nonFieldLevelPermissionsGroups = _.groupBy(
      nonFieldLevelPermissionsData,
      (item) => item.groupKey
    );

    const fieldLevelPermissionsGroups = _.groupBy(
      fieldLevelPermissionsData,
      (item) => item.groupKey
    );

    allNonFieldLevelPermissionsGroups = {
      ...allNonFieldLevelPermissionsGroups,
      ...nonFieldLevelPermissionsGroups,
    };
    Object.keys(fieldLevelPermissionsGroups).forEach((key) => {
      if (allFieldLevelPermissionsGroups[key]) {
        allFieldLevelPermissionsGroups[key] = [
          ...allFieldLevelPermissionsGroups[key],
          ...fieldLevelPermissionsGroups[key],
        ];
      } else {
        allFieldLevelPermissionsGroups[key] = fieldLevelPermissionsGroups[key];
      }
    });
  });

  return {
    nonFieldLevelPermissionsGroups: allNonFieldLevelPermissionsGroups,
    fieldLevelPermissionsGroups: allFieldLevelPermissionsGroups,
  };
};
